











































































































































































































































































import { Post, Cid, User, Id, WallReactionData, PostConnection } from 'types'
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import { $ } from 'bits/jquery'
import { Getter, State, Action, namespace } from 'vuex-class'

import { postColorTailwindClass } from 'bits/post_color'
import { isUrl } from 'bits/url'

import SurfacePostAuthor from 'vuecomponents/SurfacePostAuthor.vue'
import SurfacePostWords from 'vuecomponents/surface_post_words.vue'
import SurfacePostAttachment from 'vuecomponents/SurfacePostAttachment.vue'
import SurfacePostModeration from 'vuecomponents/SurfacePostModeration.vue'
import SurfacePostReactionNew from 'vuecomponents/surface-post-reaction-new.vue'
import SurfacePostComments from 'vuecomponents/SurfacePostComments.vue'
import SurfacePostCommentsIcon from 'vuecomponents/SurfacePostCommentsIcon.vue'
import SurfacePostMoreActions from 'vuecomponents/SurfacePostMoreActions.vue'
import SurfacePostAttachmentEmbedControl from 'vuecomponents/SurfacePostAttachmentEmbedControl.vue'

import { mathifyElement } from 'bits/math'
import { link } from 'bits/autolinker'
import { CONFIRM_DELETE_POST } from 'bits/confirmation_dialog'
import { BeethovenDisplayAttributes } from '@padlet/beethoven-client'
import { BeethovenLuminance } from '@padlet/beethoven-client/lib/types'
import { observerSizeChange } from 'bits/resize_observer'
import overflowBorderRadiusTransformFixStyle from 'bits/overflow_border_radius_transform_fix'

@Component({
  components: {
    SurfacePostAuthor,
    SurfacePostWords,
    SurfacePostAttachment,
    SurfacePostModeration,
    SurfacePostReactionNew,
    SurfacePostComments,
    SurfacePostCommentsIcon,
    SurfacePostMoreActions,
    SurfacePostAttachmentEmbedControl,
  },
})
export default class SurfacePostBeingShowedNew extends Mixins() {
  $el!: HTMLDivElement
  $refs!: {
    awaitingApproval: HTMLDivElement
    beforeAttachment: HTMLDivElement
    userContent: HTMLDivElement
    postContent: HTMLDivElement
    attachment: SurfacePostAttachment
    body: HTMLParagraphElement
    socialContentTopBar: HTMLDivElement
  }
  @Prop() index!: number
  @Prop() post!: Post
  @Prop() edit!: boolean
  @Prop() isLast!: boolean
  @Prop() fitHeightToContainer!: boolean
  @Prop() verticallyCenterContent!: boolean

  // **** GENERAL SHOW ATTRIBUTES ****
  @Getter colorScheme!: 'light' | 'dark'
  @Getter xAuthor!: boolean
  @Getter xPostCommentsInPanel!: boolean
  @Getter isStream!: boolean
  @Getter isCanvas!: boolean
  @Getter isMap!: boolean
  @Getter isTimeline!: boolean
  @Getter fontId!: number
  @Getter dir!: 'ltr' | 'rtl' | 'auto'
  @Getter isUsingNewSurfaceShadows!: boolean

  @State isSafari!: boolean

  get isPadletColorSchemeDark(): boolean {
    return this.colorScheme === 'dark'
  }

  get postColorClass(): string {
    return postColorTailwindClass({ postColor: this.post.color, isLightColorScheme: this.colorScheme == 'light' })
  }

  get overflowBorderRadiusTransformFixStyle(): Record<string, string> {
    return overflowBorderRadiusTransformFixStyle(this.isSafari)
  }

  @namespace('postConnection').State postToConnectFromId!: Id
  @namespace('postConnection').Getter connections!: PostConnection[]

  areConnected(post1Id, post2Id) {
    return (
      this.connections.filter((c) => {
        return (
          (c.from_wish_id === post1Id && c.to_wish_id === post2Id) ||
          (c.from_wish_id === post2Id && c.to_wish_id === post1Id)
        )
      }).length > 0
    )
  }

  get xConnect(): boolean {
    return (
      !!this.postToConnectFromId &&
      this.postToConnectFromId !== this.post.id &&
      !this.areConnected(this.post.id, this.postToConnectFromId)
    )
  }

  get subject(): string | undefined {
    return this.post.subject
  }

  get xSubject(): boolean {
    return !!this.subject
  }

  get body(): string | undefined {
    return this.post.body ? this.autoLink(this.post.body) : undefined
  }

  get tailwindFontClass(): string {
    switch (this.fontId) {
      case 1:
        return 'font-sans'
      case 2:
        return 'font-serif'
      case 3:
        return 'font-cursive'
      case 4:
        return 'font-padlet-monospace'
      default:
        return 'font-sans'
    }
  }

  autoLink(text: string) {
    const linkedText = link(text, {
      replaceFn: (match: any) => {
        const tag = match.buildTag()
        tag.setAttr('rel', 'noopener nofollow ugc')
        tag.setAttr('data-bridged-link', 'external')
        return tag
      },
    })
    return linkedText
  }

  get xBody(): boolean {
    return !!this.body
  }

  get xWords(): boolean {
    return !!this.post.subject || !!this.post.body
  }

  /**
   * If the more button is on top of attachment, we make it overlay the attachment
   * Otherwise, we make the post text avoid the more button with a div with float: right
   */
  get xInvisibleFloatingDiv(): boolean {
    if (!this.xAuthor && this.xSubject) return true
    if (!this.xAuthor && !this.xSubject && !this.xAttachment) return true
    return false
  }

  get xOverlayForMoreButtons(): boolean {
    if (this.xAuthor) return false
    return !this.xInvisibleFloatingDiv
  }

  performPostUpdateActions(): void {
    this.$nextTick(() => {
      $(this.$refs.body)
        .find('var')
        .each((_index, el) => {
          if (!el.children[0] || el.children[0].className !== 'katex') {
            mathifyElement(el)
          }
        })
      const bridgedLinkAttr = { 'data-bridged-link': 'external' }
      $(this.$refs.body)
        .find('a[href^=h]')
        .attr({ target: '_blank', rel: 'noopener nofollow ugc', ...bridgedLinkAttr })
    })
  }

  @Watch('body')
  handleBodyChanged(): void {
    this.performPostUpdateActions()
  }

  /**
   * Only for timeline: the whole post can be scrolled.
   */
  get isWishContentScrollable(): boolean {
    return this.isTimeline || this.isMap
  }

  /**
   * Only load attachment when there is one and when post is in viewport
   */
  get xAttachment(): boolean {
    const attachment = this.post.attachment
    const hasAttachment = !!attachment && isUrl(attachment)
    return hasAttachment
  }

  // STALKER BAR

  get xSocialContent(): boolean {
    return !this.isPostNotApproved && (this.xComments || this.xReactions)
  }

  // REACTIONS

  @Getter isReactable!: boolean
  @Getter reactionData!: WallReactionData
  @namespace('reaction').State postIdBeingReactedTo!: Id
  @namespace('reaction').Getter('reactionIdsByPost') wallReactionIdsByPost!: { [wishId: number]: string[] }
  @namespace('browser').Getter isPhone!: boolean

  @namespace('reaction').Action startEditingReaction!: (payload: {
    postId: Id
    dropdownLeft?: number
    dropdownWidth?: number
    dropdownTop?: number
  }) => void

  get postReactionIds(): string[] {
    if (!this.post.id) return []
    return this.wallReactionIdsByPost[this.post.id] || []
  }

  get xReactions(): boolean {
    // when a user is viewing a wall with reaction disabled and then reaction is enabled + someone react to something
    // the realtime message for new reaction may come before the reaction enable message
    // => wait for reactionData to be available before showing reactions
    return (this.isReactable || this.postReactionIds.length > 0) && !!this.reactionData
  }

  get isBeingReacted(): boolean {
    return this.postIdBeingReactedTo === this.post.id
  }

  editReaction(): void {
    if (this.isPhone) {
      this.startEditingReaction({ postId: this.post.id as number })
      return
    }
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent reaction event when the post is being dragged
      return
    }

    const { left, top, width } = this.$refs.socialContentTopBar.getBoundingClientRect()

    this.startEditingReaction({
      postId: this.post.id as number,
      dropdownLeft: left,
      dropdownTop: top,
      dropdownWidth: width,
    })
  }

  // COMMENTS

  @Getter isCommentable!: boolean
  @namespace('comment').State commentBeingEditedId!: Id
  @namespace('comment').Getter('commentIdsByPost') wallCommentIdsByPost!: { [wishId: number]: string[] }
  @namespace('comment').State('commentEntities') wallComments!: Comment[]

  get postCommentIds(): string[] {
    if (!this.post.id) return []
    return this.wallCommentIdsByPost[this.post.id] || []
  }

  get xComments(): boolean {
    // Turn comments off when switching to Backchannel
    return this.post.published === true && (this.isCommentable || this.postCommentIds.length > 0)
  }

  // ATTACHMENT

  @namespace('attachment').Getter linkDisplayAttributesForUrl!: (attachment: string) => BeethovenDisplayAttributes

  xEmbedControl = false
  embedData: {
    downloadUrl?: string
    isDownloadable?: boolean
  } = {}
  embedControlPositionStyle = {}
  embedControlRepositionObserver: any | null = null

  get attachmentAttributes(): BeethovenDisplayAttributes | null {
    if (!this.post.attachment) return null
    return this.linkDisplayAttributesForUrl(this.post.attachment)
  }

  get attachmentLuminance(): BeethovenLuminance | null {
    return (this.attachmentAttributes && this.attachmentAttributes.image_luminance) || null
  }

  postMessageToAttachment(event: string): void {
    this.$refs.attachment.postMessage(event)
  }
  calculateEmbedControlPosition(): void {
    this.$nextTick(() => {
      const DISTANCE_TO_EMBED = 8
      const embedHeight = this.$refs.attachment.$refs.embedWrapper.offsetHeight
      const margins =
        DISTANCE_TO_EMBED +
        parseInt(window.getComputedStyle(this.$refs.userContent).paddingTop, 10) +
        parseInt(window.getComputedStyle(this.$refs.attachment.$el).marginTop, 10)
      const awaitingApprovalHeight = this.$refs.awaitingApproval?.offsetHeight || 0
      const beforeAttachmentHeight = this.$refs.beforeAttachment.offsetHeight
      const postContentHeight = this.$refs.postContent.offsetHeight
      this.embedControlPositionStyle = {
        top: -(postContentHeight - embedHeight - beforeAttachmentHeight - awaitingApprovalHeight - margins) + 'px',
      }
    })
  }

  /**
   * When attachment has an inline embed (e.g. Youtube, Spotify), SurfacePostAttachment will handle rendering the embed inline
   * while the embed control will be rendered here.
   * We need to calculate embed control position and recalculate if any post content is resized with ResizeObserver.
   */
  toggleEmbedControl({ state, downloadUrl, isDownloadable }): void {
    this.xEmbedControl = state
    if (this.xEmbedControl && !this.isWishContentScrollable) {
      this.calculateEmbedControlPosition()
      this.embedControlRepositionObserver = observerSizeChange(this.$refs.postContent, () => {
        this.calculateEmbedControlPosition()
      })
      this.$refs.awaitingApproval && this.embedControlRepositionObserver?.observe(this.$refs.awaitingApproval)
      this.embedControlRepositionObserver?.observe(this.$refs.beforeAttachment)
    } else if (this.embedControlRepositionObserver) {
      this.$refs.awaitingApproval && this.embedControlRepositionObserver.unobserve(this.$refs.awaitingApproval)
      this.embedControlRepositionObserver.unobserve(this.$refs.beforeAttachment)
      this.embedControlRepositionObserver.unobserve(this.$refs.postContent)
      this.embedControlRepositionObserver = null
    }
    this.embedData = { downloadUrl, isDownloadable }
  }

  // **** PERMISSION-RELATED SHOW ATTRIBUTES ****

  @State user!: User
  @Getter canIModerate!: boolean
  @Getter canIWrite!: boolean

  get wasWrittenByCurrentUser(): boolean {
    return !!this.user.id && this.post.author_id === this.user.id
  }
  get isEditableByCurrentUser(): boolean {
    return this.canIModerate || (this.wasWrittenByCurrentUser && this.canIWrite)
  }

  // **** INTERACTIONS ****

  // Post
  @namespace('postAction').Action showPostActionMenu!: (payload: { postCid: Cid }) => void
  @namespace('postAction').Action setPostRightClickCoordinates!: (payload: {
    postRightClickCoordinates: [number, number]
  }) => void
  @namespace('post').Action startEditingPost!: (payload: { postCid: Cid }) => void
  @namespace('post').Action deletePost!: (payload: { postCid: Cid }) => void

  @State isMobile!: boolean

  tryShowActions(e: MouseEvent): void {
    if (
      this.isMobile ||
      this.xConnect ||
      ['a', 'textarea', 'input', 'select', 'option'].includes((e.target as Element).tagName?.toLowerCase()) ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    this.setPostRightClickCoordinates({ postRightClickCoordinates: [e.pageX, e.pageY] })
    this.showPostActionMenu({ postCid: this.post.cid })
  }

  tryStartEditPost(): void {
    if (this.isEditableByCurrentUser) {
      this.startEditingPost({ postCid: this.post.cid })
    }
  }

  @namespace('confirmationDialog').Action openConfirmationDialog!: (params: unknown) => void

  //Comment
  @namespace('comment').Action createComment!: (...args: any[]) => void
  @namespace('comment').Action editComment!: (...args: any[]) => void
  @namespace('comment').Action stopEditingComment!: (...args: any[]) => void
  @namespace('comment').Action startEditingComment!: (...args: any[]) => void
  @namespace('comment').Action showCommentActionMenu!: (...args: any[]) => void
  @Action showCommentsPanel!: (payload) => void

  // **** POST APPROVAL ****

  @namespace('post').Action approvePost!: (payload: { postCid: Cid }) => void

  get isPostNotApproved(): boolean {
    return !this.post.published
  }

  get postApprovalBgColorClass(): string {
    // match the color in SurfacePostAttachmentButton.vue
    switch (this.post.color) {
      case 'red':
        return !this.isPadletColorSchemeDark ? 'bg-scarlet-200' : 'bg-scarlet-800'
      case 'orange':
        return !this.isPadletColorSchemeDark ? 'bg-canary-200' : 'bg-tangerine-800'
      case 'green':
        return !this.isPadletColorSchemeDark ? 'bg-park-200' : 'bg-park-800'
      case 'blue':
        return !this.isPadletColorSchemeDark ? 'bg-oceanic-200' : 'bg-oceanic-800'
      case 'purple':
        return !this.isPadletColorSchemeDark ? 'bg-grape-200' : 'bg-grape-800'
      default:
        return !this.isPadletColorSchemeDark ? 'bg-light-ui-200' : 'bg-dark-ui-200'
    }
  }

  confirmDelete(): void {
    // just delete new/empty posts
    if (!this.post.id || (!this.post.body && !this.post.subject && !this.post.attachment)) {
      this.deletePost({ postCid: this.post.cid })
    }

    this.openConfirmationDialog({
      ...CONFIRM_DELETE_POST,
      afterConfirmActions: [{ type: 'post/deletePost', payload: { postCid: this.post.cid } }],
      xShadow: this.isUsingNewSurfaceShadows,
    })
  }

  // **** LIFECYCLE ****
  mounted() {
    this.$nextTick(() => {
      this.performPostUpdateActions()
    })
  }
}
